import { useState } from "react";
import Select from 'react-select';

import Botao from "componentes/Botao";
import Input from "componentes/Input";
import style from "./FormDesaparecimento.module.scss";
import Modal from "componentes/Modal";

const FormDesaparecimento = () => {

 


  const [nomeProprietario, setNomeProprietario] = useState('');
  const [nomeAnimal, setNomeAnimal] = useState('');   
  const options = [
    { value: 'cachorro', label: 'Cachorro(a)' },
    { value: 'gato', label: 'Gato(a)' },
    { value: 'outro', label: 'Outro' }
  ];
  const [opcaoEscolhida, setOpcaoEscolhida] = useState({});
  const [diaDesaparecimento, setDiaDesaparecimento] = useState('');
  const [horaDesaparecimento, setHoraDesaparecimento] = useState('');
  const [bairroDesaparecimento, setBairroDesaparecimento] = useState('');
  const [caracteristicaAnimal, setCaracteristicaAnimal] = useState('');
  const [openModal, setOpenModal] = useState(false);  


 
  function onSubmit(e){
    e.preventDefault()
    setOpenModal(true)    
  }

  const handleChange = (item)=> {
    console.log('selecionado', item)
  }

  const estiloSelect = {
    control: (styles) => ({...styles, backgroundColor: '#e8e7e7',width: '300px', borderRadius: 'none'})

  }

  const alterarCaracteristicas = (e) => {
    setCaracteristicaAnimal(e.target.value);
  }
  
  return (
    <section className={style.container}>      
        <h1 className={style.titulo}>Informe os dados do animal desaparecido</h1>      

      <form className={style.formulario} onSubmit={onSubmit}>


        <Input 
          label="Nome do Proprietário"          
          value={nomeProprietario}
          aoAlterado={value => setNomeProprietario(value)}
          className={style.campo}        
        />
        
        
        <Input 
          label="Nome do Animal"          
          value={nomeAnimal}
          aoAlterado={value => setNomeAnimal(value)}
          className={style.campo}          
        />

        <label>Selecione o tipo de animal:</label>        
        <Select           
          options={options}
          onChange={handleChange}
          isSearchable={true}
          styles={estiloSelect}
          defaultValue={[options[0]]}          
        />        
        
        <Input 
          label="Dia do desaparecimento"          
          value={diaDesaparecimento}
          aoAlterado={value => setDiaDesaparecimento(value)}
          className={style.campo}
          tipo="date"          
        />       
                
        <Input 
          label="Hora do desaparecimento"          
          value={horaDesaparecimento}
          aoAlterado={value => setHoraDesaparecimento(value)}
          className={style.campo}
          tipo="time"          
        />       
         
        <Input 
          label="Digite o bairro"          
          value={bairroDesaparecimento}
          aoAlterado={value => setBairroDesaparecimento(value)}
          className={style.campo}                 
        />

        <label>Características pessoais do animal</label>
        <textarea           
          rows="5" cols="33"          
          value={caracteristicaAnimal}
          onChange={alterarCaracteristicas}
          className={style.campo}         
          placeholder="(Ex.: cicatriz na orelha, mancha no olho...)"
          maxLength={100}        
                 
        /> 

        
        <div className={style.botao}>
          <Botao tipo="submit">Enviar</Botao>
        </div>       
      </form>
              
        {/* <div>
          <p>proprietario: {nomeProprietario}</p>
          <p>animal: {nomeAnimal}</p>
          
          <p>dia desaparecimento: {diaDesaparecimento}</p>
          <p>hora: {horaDesaparecimento}</p>
          <p>bairro: {bairroDesaparecimento}</p>
          <p>caracteristicas: {caracteristicaAnimal}</p>
        </div> */}

      <Modal isOpen={openModal} setOpenModal={() => setOpenModal(!openModal)}>
      <p>Em desenvolvimento</p>
      </Modal>
      
    </section>
  )
}

export default FormDesaparecimento;